import { render, staticRenderFns } from "./rescue.vue?vue&type=template&id=896a19c6&"
import script from "./rescue.vue?vue&type=script&lang=js&"
export * from "./rescue.vue?vue&type=script&lang=js&"
import style0 from "./rescue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports